import strings from 'strings';

/**
 * ROXY has nine authored states. Motion is never the only signal — every state
 * also has a word that is rendered in the status line under her name.
 */
export const ROXY_STATES = {
    IDLE: 'idle',
    GREETING: 'greeting',
    LISTENING: 'listening',
    THINKING: 'thinking',
    SPEAKING: 'speaking',
    WORKING: 'working',
    SUCCESS: 'success',
    ALERT: 'alert',
    HANDOFF: 'handoff',
};

export const roxyStateWord = (state) => {
    const words = strings.APPLICANT.REPUTATION_REPORT.ROXY;
    return words[(state || ROXY_STATES.IDLE).toUpperCase()] || words.IDLE;
};
